import type { ReactNode } from 'react';

import { PlanCard, PlanSectionHeading } from '@/components/MeetingPlan/PlanSection';

interface MeetingPlanSectionCardProps {
    title: string;
    /** One line under the title, saying what the section is for. */
    description?: string;
    /** The section's own control, on the title's line — what a reader adds to that section. */
    action?: ReactNode;
    dataTestId: string;
    children: ReactNode;
}

/**
 * One block of the plan editor, in the very card the plan itself is read in, with the section's own
 * control beside its title. Written once here because the editor draws eight of them.
 */
export const MeetingPlanSectionCard = ({
    title,
    description,
    action,
    dataTestId,
    children,
}: MeetingPlanSectionCardProps) => (
    <PlanCard dataTestId={dataTestId}>
        <div className={'flex flex-wrap items-start justify-between gap-4'}>
            {/* The heading takes the room its description needs; the control keeps its own width. */}
            <div className={'min-w-0 flex-1'}>
                <PlanSectionHeading
                    title={title}
                    description={description}
                />
            </div>

            {action}
        </div>

        <div className={'mt-6'}>{children}</div>
    </PlanCard>
);
